import {
  DownloadOutlined,
  EditOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import dayjs from "dayjs";
import {
  Button,
  Input,
  Table,
  Space,
  message,
  Upload,
  Breadcrumb,
  Tag,
} from "antd";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import Papa from "papaparse";
import useDebounce from "../../../hooks/useDebounce";
import WelcomeTopbar from "../../../components/common/header/WelcomeTopbar";
import LogoLoader from "../../../components/common/LogoLoader";
import { getTagRequest } from "../../../api/requests/tag";
import { doDownload } from "../../../utils/download";
import { DATE_FORMAT } from "../../../utils/date";

const { Search } = Input;

function TagsPage() {
  const navigate = useNavigate();
  const [name, setName] = useState();
  const debouncedName = useDebounce(name, 500);

  const params = {
    name: debouncedName,
  };

  const { data: tagListRes, isLoading: isLoadingTagList } = useQuery({
    queryKey: ["tag", params],
    queryFn: async () => {
      const res = await getTagRequest({
        params,
      });
      return res.data?.data;
    },
  });

  function navigateToUpdate(id) {
    navigate(`/setup/tags/update/${id}`);
  }

  function renderTable() {
    const columns = [
      {
        title: "EPC",
        dataIndex: "epc",
        key: "epc",
        render: (text) => text ?? "-",
      },
      {
        title: "Serial",
        dataIndex: "serial",
        key: "serial",
        render: (text) => text ?? "-",
      },
      // {
      //   title: "Model",
      //   dataIndex: "model",
      //   key: "model",
      //   render: (text) => text ?? "-",
      // },
      // {
      //   title: "Type",
      //   dataIndex: "type",
      //   key: "type",
      //   render: (text) => text ?? "-",
      // },
      // {
      //   title: "Provider",
      //   dataIndex: "provider",
      //   key: "provider",
      //   render: (text) => text ?? "-",
      // },
      // {
      //   title: "Brand",
      //   dataIndex: "brand",
      //   key: "brand",
      //   render: (text) => text ?? "-",
      // },
      {
        title: "Status",
        key: "state",
        render: ({ state }) => {
          switch (state) {
            case "COMMISSIONED":
              return <Tag color="blue">COMMISSIONED</Tag>;
            case "AVAILABLE":
              return <Tag color="green">AVAILABLE</Tag>;
            case "DECOMMISSIONED":
              return <Tag color="grey">DECOMMISSIONED</Tag>;
            default:
              return state;
          }
        },
      },
      {
        title: "Created At",
        key: "createdAt",
        render: ({ createdAt }) => {
          return dayjs(createdAt).format(DATE_FORMAT);
        },
      },
      {
        title: "Updated At",
        key: "updatedAt",
        render: ({ updatedAt }) => {
          return dayjs(updatedAt).format(DATE_FORMAT);
        },
      },
      {
        title: "Action",
        render: (details) => {
          console.log("details----->", details);
          return (
            <Space>
              <Button
                onClick={() => {
                  navigateToUpdate(details._id);
                }}
                type="primary"
              >
                <EditOutlined />
              </Button>
            </Space>
          );
        },
        key: "action",
      },
    ];

    if (isLoadingTagList) {
      return <LogoLoader />;
    }

    return (
      <Table
        dataSource={tagListRes || []}
        columns={columns}
        rowKey={"_id"}
        // pagination={{
        //   total: receiveSizeBeamListRes?.count || 0,
        //   showSizeChanger: true,
        //   onShowSizeChange: onShowSizeChange,
        //   onChange: onPageChange,
        // }}
        pagination={false}
        style={{
          overflow: "auto",
        }}
      />
    );
  }

  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);

  const handleFileUpload = (info) => {
    const file = info.fileList?.[0]?.originFileObj;
    if (!file) {
      console.error("File object not found");
      return;
    }

    // Check if the file is a CSV
    if (file.type !== "text/csv") {
      message.error("Only CSV files are allowed!");
      return;
    }

    // Parse the file
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete: (result) => {
        const parsedData = result.data;

        // Handle empty or invalid CSV
        if (!parsedData.length) {
          message.error("The CSV file is empty or invalid.");
          return;
        }

        // Process and set data for the table
        const csvColumns = Object.keys(parsedData[0]).map((key) => ({
          title: key,
          dataIndex: key,
          key,
        }));
        setColumns(csvColumns);
        setData(parsedData);
      },
      error: (error) => {
        console.error("Error parsing CSV:", error);
        message.error("Failed to parse the CSV file.");
      },
    });
  };

  return (
    <div className="flex flex-col">
      <WelcomeTopbar />
      <div className="flex flex-col gap-6">
        <div className="flex flex-col gap-6 pb-6">
          <div className="flex min-h-14 justify-between rounded-t-xl bg-[#D1DFFF] px-6 py-3">
            <Breadcrumb
              items={[
                {
                  title: <div className="text-lg">Tags</div>,
                },
              ]}
            />
            {/* <div>
              <Button
                onClick={() => {
                  navigate("/setup/tags/add");
                }}
                type="primary"
              >
                Create Tag
              </Button>
            </div> */}
          </div>
          <div className="flex flex-col gap-6 px-6">
            <div className="flex items-end justify-between gap-6">
              <div className="flex items-center gap-4">
                <Button
                  icon={<DownloadOutlined />}
                  onClick={() => {
                    // doDownload("/assets/csv/tag-sample.csv", "tag-sample.csv");
                    doDownload(
                      "/assets/csv/productassets.csv",
                      "productassets.csv",
                    );
                  }}
                >
                  Download Template
                </Button>
                <Upload
                  accept=".csv"
                  showUploadList={false}
                  beforeUpload={() => false}
                  onChange={handleFileUpload}
                >
                  <Button icon={<UploadOutlined />}>Upload CSV</Button>
                </Upload>
              </div>
              <div>
                <Search
                  placeholder="Search"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                />
              </div>
            </div>
            {data.length > 0 && (
              <Table
                style={{ marginTop: "20px" }}
                dataSource={data.map((row, index) => ({
                  ...row,
                  key: index,
                }))}
                columns={columns}
                pagination={{ pageSize: 10 }}
              />
            )}
            {renderTable()}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TagsPage;
